import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';

export const importFileTypesProc: (keyof typeof UploadFileTypesEnum)[] = ['PLAN', 'PLAN_CORRECTION'];
